
export default {
  props: ['error'],
  head() {
    return {
      title: 'Vitesy - 404 Page not found'
    }
  }
}
